import {
  CensusDataDp05DemographicAndHousingEstimates2023Response,
  CensusDataS1501EducationalAttainment2023Response,
  CensusDataS2503FinancialCharacteristics2023Response,
} from 'api/entities/CensusData'
import { apiSlice, defaultTransformFn } from 'api/apiSlice'

export interface CensusDataQueryParams {
  zipCodes: string[]
}

const censusDataApiTags = apiSlice.enhanceEndpoints({
  addTagTypes: ['DemographicAndHousingCharacteristics', 'EducationalAttainment', 'FinancialCharacteristics']
})

export const censusDataApi = censusDataApiTags.injectEndpoints({
  endpoints: build => ({
    getDemographicAndHousingCharacteristics: build.query<
      Record<string, CensusDataDp05DemographicAndHousingEstimates2023Response>,
      CensusDataQueryParams
    >({
      query: ({ zipCodes }) => {
        return {
          url: `censusData/demographicAndHousingCharacteristics`,
          method: 'POST',
          body: { zipCodes },
          isContext: true,
          isAgency: false
        }
      },
      transformResponse: defaultTransformFn,
      providesTags: (result, error, { zipCodes }) => [
        {
          type: 'DemographicAndHousingCharacteristics',
          id: [...zipCodes].sort().join(',')
        }
      ]
    }),
    getEducationalAttainment: build.query<
      Record<string, CensusDataS1501EducationalAttainment2023Response>,
      CensusDataQueryParams
    >({
      query: ({ zipCodes }) => {
        return {
          url: `censusData/educationalAttainment`,
          method: 'POST',
          body: { zipCodes },
          isContext: true,
          isAgency: false
        }
      },
      transformResponse: defaultTransformFn,
      providesTags: (result, error, { zipCodes }) => [
        {
          type: 'EducationalAttainment',
          id: [...zipCodes].sort().join(',')
        }
      ]
    }),
    getFinancialCharacteristics: build.query<
      Record<string, CensusDataS2503FinancialCharacteristics2023Response>,
      CensusDataQueryParams
    >({
      query: ({ zipCodes }) => {
        return {
          url: `censusData/financialCharacteristics`,
          method: 'POST',
          body: { zipCodes },
          isContext: true,
          isAgency: false
        }
      },
      transformResponse: defaultTransformFn,
      providesTags: (result, error, { zipCodes }) => [
        {
          type: 'FinancialCharacteristics',
          id: [...zipCodes].sort().join(',')
        }
      ]
    })
  })
})

export const {
  useGetDemographicAndHousingCharacteristicsQuery,
  useLazyGetDemographicAndHousingCharacteristicsQuery,
  useGetEducationalAttainmentQuery,
  useLazyGetEducationalAttainmentQuery,
  useGetFinancialCharacteristicsQuery,
  useLazyGetFinancialCharacteristicsQuery
} = censusDataApi
